import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'dr-customer-offers-ui-open-container',
  templateUrl: './open-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OpenContainerComponent {
  protected isChartRoute$: Observable<boolean> = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    startWith(null),
    map(() => this.router.url.includes('/open/chart'))
  );

  constructor(private router: Router) {}
}
